import React from "react";
import { CssBaseline, ThemeProvider, createTheme, Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SchoolVaccinationTable from "./components/SchoolVaccinationTable";
import SchoolDetail from "./components/SchoolDetail";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MapPage from "./components/MapPage";
import About from "./components/About";
import { HelmetProvider } from "react-helmet-async";

const theme = createTheme({
  palette: {
    mode: "light",
  },
  typography: {
    fontFamily: `"canada-type-gibson", sans-serif`,
  },
});

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* Main container with flex layout - takes full viewport height */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Header />

          {/* Content container - will grow to fill available space */}
          <Box sx={{ flex: "1 0 auto" }}>
            <Router>
              <Routes>
                <Route path="/" element={<SchoolVaccinationTable />} />
                <Route path="/school" element={<SchoolDetail />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/about" element={<About />} />
              </Routes>
            </Router>
          </Box>

          {/* Footer - will stay at the bottom */}
          <Footer />
        </Box>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
